module.exports = __webpack_public_path__ + "img/csr_banner_01.62dfe40e.jpg";